import React, { useState, useEffect } from "react";
import { useLazyLoadQuery, graphql } from "react-relay";
import "./PGAModelBuilderLoadFilters.css";

const GET_FILTERS = graphql`
  query PGAModelBuilderLoadFiltersQuery {
    pgaTourGetSavedModelFilters {
      id
      name
    }
  }
`;

export default function PGAModelBuilderLoadFilters({
  loadFilter,
  filterSaves,
}) {
  const data = useLazyLoadQuery(
    GET_FILTERS,
    {},
    { fetchPolicy: "network-only", fetchKey: filterSaves }
  );

  return (
    <div
      style={{
        display: "flex",
        width: "90%",
        flexWrap: "wrap",
        rowGap: "10px",
        columnGap: "10px",
        justifyContent: "center",
      }}
    >
      {data.pgaTourGetSavedModelFilters.length === 0 ? (
        <p>You have no saved filters.</p>
      ) : null}

      {data.pgaTourGetSavedModelFilters.map((filter) => {
        return (
          <button
            key={filter.id}
            className="load-filter-button"
            style={{
              width: "40%",
              height: "30px",
              display: "block",

              border: "1px solid black",

              padding: 0,
              font: "inherit",
              cursor: "pointer",
              outline: "inherit",
            }}
            onClick={() => loadFilter(filter.id)}
          >
            {filter.name}
          </button>
        );
      })}
    </div>
  );
}
